module.exports = __webpack_public_path__ + "static/media/icici.5d667d59.svg";